<template>
  <div style="position: relative;z-index: 99999999999;">
    <section class="bg-default mod-newsletter py-5">
      <picture class="bg-picture">
        <img class="img-fluid js-lazy-img"
          src="https://www.iase-certifications.com/wp-content/uploads/sites/39/2022/12/bg-newsletter-home-aspect-ratio-1920-440-1.jpg"
          data-src="https://www.iase-certifications.com/wp-content/uploads/sites/39/2022/12/bg-newsletter-home-aspect-ratio-1920-440-1.jpg"
          title="" alt="订阅我们的时事通讯。" width="682" height="449">
      </picture>
      <div class="container py-lg-5">
        <div class="row">
          <div class="d-lg-flex align-items-center">
            <div class="col-12 col-lg-5 mb-4 mb-lg-0">
              <h2>
                <font dir="auto" style="vertical-align: inherit;">
                  <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.newsletterTitle') }}</font>
                </font>
              </h2>
              <h3 class="h4 mt-2">
                <font dir="auto" style="vertical-align: inherit;">
                  <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.newsletterDesc') }}</font>
                </font>
              </h3>
            </div>
            <div class="col-12 col-lg-5 offset-lg-1 form-white">

              <div class="wpcf7 js" id="wpcf7-f1180-o2" lang="pt-BR" dir="ltr" data-wpcf7-id="1180">
                <div class="screen-reader-response">
                  <p role="status" aria-live="polite" aria-atomic="true"></p>
                  <ul></ul>
                </div>
                <form action="" method="post" class="wpcf7-form init" aria-label="Formulários de contato"
                  novalidate="novalidate" data-status="init">
                  <div class="form-floating mb-2">
                    <input size="40" maxlength="400"
                      class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control"
                      aria-required="true" aria-invalid="false" :placeholder="$t('footer.placeholderName')" v-model="form.name" type="text"
                      name="nome"><label for="">
                      <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.placeholderName') }}</font>
                      </font>
                    </label>
                  </div>
                  <div class="form-floating mb-4 mb-sm-3">
                    <input size="40" maxlength="400"
                      class="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email form-control"
                      aria-required="true" aria-invalid="false" :placeholder="$t('footer.placeholderEmail')" v-model="form.email" type="email"
                      name="email"><label for="">
                      <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.placeholderEmail') }}</font>
                      </font>
                    </label>
                  </div>
                   <div class="form-floating mb-4 mb-sm-3">
                    <input size="40" maxlength="400"
                      class="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email form-control"
                      aria-required="true" aria-invalid="false" :placeholder="$t('footer.placeholderWechat')" v-model="form.wx" type="email"
                      name="email"><label for="">
                      <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.placeholderWechat') }}</font>
                      </font>
                    </label>
                  </div>
                  <div class="form-floating mb-4 mb-sm-3">
                    <input size="40" maxlength="400"
                      class="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email form-control"
                      aria-required="true" aria-invalid="false" :placeholder="$t('footer.placeholderPhone')" v-model="form.mobile" type="email"
                      name="email"><label for="">
                      <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.placeholderPhone') }}</font>
                      </font>
                    </label>
                  </div>
                  <div class="form-check sm">
                    <input class="form-check-input" type="checkbox" id="termosNews" v-model="iCan">
                    <label class="form-check-label" for="termosNews">
                      <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">
                          {{ $t('common.agree') }}</font>
                      </font><a target="_blank" :href="$i18n.locale == 'zh-TW' ? 'https://iase-certifications.com.hk/私隱政策-IASEHK.pdf' : 'https://iase-certifications.com.hk/PRIVACYPOLICY-IASEHK.pdf'"
                        rel="noopener" id="newsPoliticas">
                        <font dir="auto" style="vertical-align: inherit;">
                          <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.privacyPolicy') }}</font>
                        </font>
                      </a>
                      <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('common.and') }}</font>
                      </font><a target="_blank" :href="$i18n.locale == 'zh-TW' ? 'https://iase-certifications.com.hk/用戶協議-IASEHK.pdf' : 'https://iase-certifications.com.hk/TERMSOFSERVICE-IASEHK.pdf'"
                        rel="noopener" id="newsTermos">
                        <font dir="auto" style="vertical-align: inherit;">
                          <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.termsConditions') }}</font>
                        </font>
                      </a>
                    </label>
                  </div>
                  <div class="box-btn-send mt-4 w-xs-100">
                    <el-button :disabled="disabled" :loading="loading" @click="send">{{ $t('common.send') }}</el-button>
                  </div>
                  <div class="wpcf7-response-output" aria-hidden="true"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer ">
      <div class="container cols-top">
        <div class="row">
          <div class="col-12 col-lg-3 col-xl-4 pe-lg-4 mb-4 mb-lg-0 text-center text-sm-start">
            <a href="https://www.iase-certifications.com/" class="logo" aria-label="IASE认证">
              <img width="280" height="84" class="img-fluid entered lazyloaded"
                src="@/assets/home/header-logo2.png" />
            </a>
          </div>
          <div class="col-12 col-lg-4 col-xl-3 mb-4 mb-sm-0 order-sm-3 text-center text-sm-start">
            <div class="mb-2">
              <div class="icon-flex sm">
                <i class="las la-map-marker"></i>
                <font dir="auto" style="vertical-align: inherit;">
                  <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.address') }}</font>
                </font>
              </div>
            </div>
            <div class="mb-2">
              <div class="icon-flex sm">
                 <i class="las la-envelope"></i>
                <font dir="auto" style="vertical-align: inherit;">
                  <font dir="auto" style="vertical-align: inherit;">info@iase-certifications.cn</font>
                </font>
              </div>
            </div>
            <img style="width: 300px;" class="mt20" src="@/assets/home/code.png" alt="">
            
          </div>
          <div class="col-12 col-lg-5 mb-sm-4 mb-lg-0 order-sm-2">
            <ul id="menu-menu-rodape-en" class="nav">
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2047"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2047"><router-link to="/aboutus/about-iase" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.aboutIase') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2048"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2048"><router-link title="认证"
                  to="/certification/certificate" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.professionalCertification') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2050"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2050"><router-link 
                  to="/aboutus/network" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.globalNetwork') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2051"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2051"><router-link
                  to="/aboutus/partner" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.partners') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2052"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2052"><router-link
                  to="/testimonials" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.testimonials') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2053"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2053"><router-link
                  to="/aboutus/team" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.leadershipTeam') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2054"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2054"><router-link
                  to="/articles" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.examCalendar') }}</font>
                  </font>
                </router-link></li>
              
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2055"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2055"><router-link
                  to="/articles" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.news') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2056"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2056"><router-link
                  to="/about-esg" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.aboutEsg') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2057"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2057"><router-link
                  to="/contact" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.contactUs') }}</font>
                  </font>
                </router-link></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2058"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2058"><router-link to="/useful-links" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.usefulLinks') }}</font>
                  </font>
                </router-link></li>
              <!-- <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2059"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2059"><a title="词汇表"
                  href="https://www.iase-certifications.com/glossary/" >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">词汇表</font>
                  </font>
                </a></li> -->
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2059"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2060"><a target="_blank" :href="$i18n.locale == 'zh-TW' ? 'https://iase-certifications.com.hk/用戶協議-IASEHK.pdf' : 'https://iase-certifications.com.hk/TERMSOFSERVICE-IASEHK.pdf'">
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.termsAndConditions') }}</font>
                  </font>
                </a></li>
              <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-2060"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2061"><a target="_blank" :href="$i18n.locale == 'zh-TW' ? 'https://iase-certifications.com.hk/私隱政策-IASEHK.pdf' : 'https://iase-certifications.com.hk/PRIVACYPOLICY-IASEHK.pdf'">
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.privacyPolicy') }}</font>
                  </font>
                </a></li>
              <!-- <li itemscope="itemscope" itemtype="https://www.schema.org/SiteNavigationElement" id="menu-item-5551"
                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-5551"><a title="IASE章程"
                  target="_blank"
                  href="https://www.iase-certifications.com/wp-content/uploads/sites/39/2023/02/iase-articles-of-association-rev-oct-22-v2.pdf"
                  >
                  <font dir="auto" style="vertical-align: inherit;">
                    <font dir="auto" style="vertical-align: inherit;">IASE章程</font>
                  </font>
                </a></li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="copyright">
        <div class="container">
          <div class="row">
            <div class="col-12 d-sm-inline-flex align-items-center justify-content-center">
              <p>
                <font dir="auto" style="vertical-align: inherit;">
                  <font dir="auto" style="vertical-align: inherit;">{{ $t('footer.icpLicense') }}</font>
                </font>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  import { sendEmail } from '@/common/api'
export default {
  name: 'footerComponent',
  data() {
    return {
      iCan: true,
      form: {
        type: '1',
        name: '',
        email: '',
        wx: '',
        mobile: ''
      },
      loading: false
    }
  },
  computed: {
    disabled() {
      return this.form.name.trim() == '' || this.form.email.trim() == '' || this.form.wx.trim() == '' || this.form.mobile.trim() == ''
    }
  },
  methods: {
    send () {
      if (this.loading) return
      if (!this.iCan) {
        this.$message.info(this.$t('common.pleaseReadAgree'))
        return
      }
      if (this.form.name == '') {
        this.$message.info(this.$t('common.pleaseEnterName'))
        return
      }
      if (this.form.email == '') {
        this.$message.info(this.$t('common.pleaseEnterEmail'))
        return
      }
      if (this.form.wx == '') {
        this.$message.info(this.$t('common.pleaseEnterWechat'))
        return
      }
      if (this.form.mobile == '') {
        this.$message.info(this.$t('common.pleaseEnterPhone'))
        return
      }
      this.loading = true
      sendEmail(this.form).then(res => {
        this.$message.success(`${res.msg}${this.$t('common.willContactYou')}`)
        this.form = {
          type: '1',
          name: '',
          email: '',
          wx: '',
          mobile: ''
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>